import {shareOutParamBuilder} from '../../lib/paramBuilder';
import queryString from 'query-string';

export interface IShareParam {
  title;
  content;
  shareUrl;
  target?;
  invisiblePlat?;
  source?;
  captureArea?;
  type?;
}

export function callShareSDK(params: IShareParam) {
  console.log('callShareSDK', params);
  if ((window as any).ucweb) {
    (window as any).ucweb.startRequest('shell.page_share', [
      params.title,
      params.content,
      params.shareUrl,
      params.target || '',
      params.invisiblePlat || '',
      params.source || '',
      params.captureArea || '',
      params.type || '',
    ]);
  } else {
    // 兼容新版 ios 分享
    (window as any).ucapi.share.shareTo({
      id: 'All',
      name: 'All',
      url: params.shareUrl,
    });
  }
}

export function getShareOutUrl(platform) {
  const query = queryString.parse(location.search, {arrayFormat: 'bracket'});
  let param = shareOutParamBuilder.getParams(query);
  param = Object.assign(param, {
    entry1: 'shareback',
    entry2: platform,
    comment_stat: query.comment_stat || undefined,
  });
  const {url} = queryString.parseUrl(location.href);
  return `${url}?${queryString.stringify(param, {arrayFormat: 'bracket'})}`;

}
